import React, { FC } from 'react';

export const WhaleEmpty: FC = () => {
  return (
    <svg
      width='187'
      height='187'
      viewBox='0 0 187 187'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='93.5' cy='93.5' r='93' fill='url(#paint0_linear_581_101423)' />
      <mask id='path-2-inside-1_581_101423' fill='white'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M88.6272 140.721C117.874 143.162 145.772 125.72 148.212 96.4727C150.653 67.2256 128.922 41.5378 99.6746 39.0974C74.3342 36.983 51.6658 53.0139 44.4747 76.3571C37.9522 92.0612 43.2785 140.219 50.413 155.989C47.3804 158.286 41.2317 164.056 40.898 168.768C45.1829 171.583 55.0133 174.611 60.0552 164.206C63.3199 166.231 71.8678 169.132 79.9421 164.538C80.1949 160.969 76.7308 153.656 60.8517 152.962C59.1577 146.356 62.5285 137.687 72.3086 137.057C77.2915 138.981 82.7639 140.232 88.6272 140.721Z'
        />
      </mask>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M88.6272 140.721C117.874 143.162 145.772 125.72 148.212 96.4727C150.653 67.2256 128.922 41.5378 99.6746 39.0974C74.3342 36.983 51.6658 53.0139 44.4747 76.3571C37.9522 92.0612 43.2785 140.219 50.413 155.989C47.3804 158.286 41.2317 164.056 40.898 168.768C45.1829 171.583 55.0133 174.611 60.0552 164.206C63.3199 166.231 71.8678 169.132 79.9421 164.538C80.1949 160.969 76.7308 153.656 60.8517 152.962C59.1577 146.356 62.5285 137.687 72.3086 137.057C77.2915 138.981 82.7639 140.232 88.6272 140.721Z'
        fill='#EAEDF5'
      />
      <path
        d='M44.4747 76.3571L45.4519 76.763L45.4712 76.7166L45.4859 76.6687L44.4747 76.3571ZM50.413 155.989L51.0518 156.833L51.7252 156.323L51.377 155.553L50.413 155.989ZM40.898 168.768L39.8425 168.693L39.7987 169.312L40.317 169.653L40.898 168.768ZM60.0552 164.206L60.613 163.307L59.6151 162.688L59.103 163.744L60.0552 164.206ZM79.9421 164.538L80.4653 165.458L80.9575 165.178L80.9975 164.613L79.9421 164.538ZM60.8517 152.962L59.8267 153.225L60.0216 153.985L60.8055 154.019L60.8517 152.962ZM72.3086 137.057L72.6896 136.07L72.4727 135.986L72.2406 136.001L72.3086 137.057ZM147.158 96.3847C144.78 124.882 117.562 142.074 88.7152 139.667L88.5392 141.776C118.186 144.25 146.764 126.557 149.267 96.5607L147.158 96.3847ZM99.5866 40.1519C128.251 42.5437 149.55 67.72 147.158 96.3847L149.267 96.5607C151.756 66.7312 129.592 40.532 99.7626 38.043L99.5866 40.1519ZM45.4859 76.6687C52.5337 53.7905 74.7521 38.0797 99.5866 40.1519L99.7626 38.043C73.9163 35.8864 50.7978 52.2374 43.4635 76.0456L45.4859 76.6687ZM51.377 155.553C47.8874 147.839 44.7827 132.008 43.3765 116.055C42.6754 108.102 42.4009 100.165 42.7047 93.2535C43.0099 86.3124 43.8951 80.5114 45.4519 76.763L43.4976 75.9513C41.7932 80.0549 40.8982 86.1626 40.5905 93.1606C40.2816 100.188 40.5615 108.221 41.2685 116.241C42.6784 132.236 45.8042 148.369 49.4489 156.425L51.377 155.553ZM41.9534 168.843C42.0949 166.846 43.5156 164.449 45.4518 162.156C47.3509 159.907 49.5863 157.942 51.0518 156.833L49.7742 155.146C48.207 156.332 45.8518 158.402 43.835 160.79C41.8552 163.135 40.0348 165.979 39.8425 168.693L41.9534 168.843ZM59.103 163.744C56.7478 168.605 53.3701 170.217 50.1368 170.388C46.8044 170.564 43.4966 169.209 41.4789 167.884L40.317 169.653C42.5842 171.142 46.3342 172.708 50.2487 172.501C54.2623 172.289 58.3208 170.212 61.0075 164.667L59.103 163.744ZM79.4188 163.619C71.805 167.951 63.69 165.215 60.613 163.307L59.4975 165.105C62.9498 167.246 71.9305 170.314 80.4653 165.458L79.4188 163.619ZM60.8055 154.019C68.5977 154.36 73.1818 156.318 75.767 158.483C78.3509 160.647 78.9868 163.048 78.8866 164.463L80.9975 164.613C81.1501 162.459 80.1804 159.419 77.1257 156.861C74.0723 154.303 68.9847 152.258 60.8979 151.905L60.8055 154.019ZM72.2406 136.001C67.0098 136.338 63.4065 138.849 61.3714 142.222C59.3597 145.556 58.915 149.67 59.8267 153.225L61.8766 152.699C61.0943 149.648 61.4881 146.125 63.1833 143.315C64.8551 140.545 67.8273 138.406 72.3766 138.113L72.2406 136.001ZM88.7152 139.667C82.9466 139.186 77.5734 137.956 72.6896 136.07L71.9275 138.044C77.0097 140.006 82.5813 141.279 88.5392 141.776L88.7152 139.667Z'
        fill='#6A7695'
        mask='url(#path-2-inside-1_581_101423)'
      />
      <path
        d='M98.6104 103.868L118.813 100.388'
        stroke='#8694B6'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M74.5476 122.588C101.532 106.412 130.342 115.555 138.766 120.029C132.614 129.211 114.075 143.133 85.4434 141.517C75.2796 140.669 71.9936 140.163 69.1282 137.936C63.8015 138.383 61.3983 145.578 60.3737 146.69C60.0434 145.864 60.9843 142.544 61.1696 140.323C61.3549 138.103 61.9654 135.946 64.9822 131.639C69.1282 126.794 73.5055 123.212 74.5476 122.588Z'
        fill='url(#paint1_linear_581_101423)'
        stroke='#6A7695'
        strokeWidth='1.05811'
      />
      <path
        d='M134.39 118.039C135.105 118.755 135.981 120.604 135.981 123.61'
        stroke='#6A7695'
        strokeWidth='1.05811'
      />
      <path
        d='M75.7609 82.8357C76.7682 81.4595 78.421 80.7598 79.3877 80.1377C78.5849 79.3805 75.5192 80.9895 74.4866 81.836C73.6605 82.5132 73.7025 83.0686 73.8681 83.3259C74.1165 83.712 75.2612 83.5184 75.7609 82.8357Z'
        fill='#6A7695'
        stroke='#6A7695'
        strokeWidth='1.05811'
      />
      <path
        d='M129.542 75.7576C128.535 74.3814 126.882 73.6817 125.915 73.0595C126.718 72.3023 129.784 73.9114 130.816 74.7579C131.642 75.4351 131.6 75.9904 131.435 76.2478C131.186 76.6338 130.042 76.4403 129.542 75.7576Z'
        fill='#6A7695'
        stroke='#6A7695'
        strokeWidth='1.05811'
      />
      <path
        d='M127.228 115.811C130.448 117.421 131.731 122.31 130.013 129.181'
        stroke='#6A7695'
        strokeWidth='1.05811'
      />
      <path
        d='M121.656 114.457C125.238 118.038 126.829 124.405 120.86 134.752'
        stroke='#6A7695'
        strokeWidth='1.05811'
      />
      <path
        d='M115.29 113.662C118.871 122.019 118.474 133.957 104.546 140.324'
        stroke='#6A7695'
        strokeWidth='1.05811'
      />
      <path
        d='M107.728 113.662C108.922 123.61 107.728 135.15 88.2295 141.517'
        stroke='#6A7695'
        strokeWidth='1.05811'
      />
      <path
        d='M98.179 114.457C96.7033 129.405 91.0162 137.139 70.7217 139.129'
        stroke='#6A7695'
        strokeWidth='1.05811'
      />
      <path
        d='M85.8413 117.641C81.4641 129.579 77.8827 132.364 63.1592 134.354'
        stroke='#6A7695'
        strokeWidth='1.05811'
      />
      <circle cx='80.857' cy='94.1861' r='5.29056' fill='#6A7695' />
      <rect
        x='80.998'
        y='91.8213'
        width='3.17433'
        height='3.17433'
        rx='1.58717'
        transform='rotate(-15 80.998 91.8213)'
        fill='white'
      />
      <circle cx='126.289' cy='86.396' r='5.29056' fill='#6A7695' />
      <rect
        x='125.963'
        y='83.623'
        width='3.17433'
        height='3.17433'
        rx='1.58717'
        transform='rotate(-15 125.963 83.623)'
        fill='white'
      />
      <defs>
        <linearGradient
          id='paint0_linear_581_101423'
          x1='52.013'
          y1='49.2472'
          x2='173.708'
          y2='164.374'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F7F9FE' />
          <stop offset='0.837155' stopColor='#F7F9FE' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_581_101423'
          x1='101.116'
          y1='114.43'
          x2='95.2286'
          y2='146.257'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
      </defs>
    </svg>
  );
};
